import { Alert } from '@time-line/components/common';
import { useProductEnabledCountries } from 'hooks/localisation/useProductEnabledCountries';
import { useLocalStorage, UserLocale } from 'hooks/userPreferences';

interface CartProductShippingInfoProps {
  productId: string;
}

export function CartProductShippingInfo({
  productId,
}: CartProductShippingInfoProps) {
  const {
    value: { countryName, countryCode },
    isLoading: isLocaleLoading,
  } = useLocalStorage(UserLocale);

  const { data: productEnabledCountries } =
    useProductEnabledCountries(productId);

  if (!productEnabledCountries) {
    return null;
  }

  if (isLocaleLoading) {
    return null;
  }

  const productShippingIsEnabled =
    productEnabledCountries.includes(countryCode);

  if (productShippingIsEnabled) {
    return null;
  }

  return (
    <Alert status="error" mt="2xs">
      {`Doesn't ship to ${countryName}`}
    </Alert>
  );
}
